// This file is auto-generated by @hey-api/openapi-ts
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { createSseClient } from "../core/serverSentEvents.gen";
import { getValidRequestBody } from "../core/utils.gen";
import { buildUrl, createConfig, createInterceptors, getParseAs, mergeConfigs, mergeHeaders, setAuthParams, } from "./utils.gen";
export var createClient = function (config) {
    if (config === void 0) { config = {}; }
    var _config = mergeConfigs(createConfig(), config);
    var getConfig = function () { return (__assign({}, _config)); };
    var setConfig = function (config) {
        _config = mergeConfigs(_config, config);
        return getConfig();
    };
    var interceptors = createInterceptors();
    var beforeRequest = function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var opts, url;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    opts = __assign(__assign(__assign({}, _config), options), { fetch: (_b = (_a = options.fetch) !== null && _a !== void 0 ? _a : _config.fetch) !== null && _b !== void 0 ? _b : globalThis.fetch, headers: mergeHeaders(_config.headers, options.headers), serializedBody: undefined });
                    if (!opts.security) return [3 /*break*/, 2];
                    return [4 /*yield*/, setAuthParams(__assign(__assign({}, opts), { security: opts.security }))];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2:
                    if (!opts.requestValidator) return [3 /*break*/, 4];
                    return [4 /*yield*/, opts.requestValidator(opts)];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    if (opts.body !== undefined && opts.bodySerializer) {
                        opts.serializedBody = opts.bodySerializer(opts.body);
                    }
                    // remove Content-Type header if body is empty to avoid sending invalid requests
                    if (opts.body === undefined || opts.serializedBody === "") {
                        opts.headers.delete("Content-Type");
                    }
                    url = buildUrl(opts);
                    return [2 /*return*/, { opts: opts, url: url }];
            }
        });
    }); };
    var request = function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, opts, url, requestInit, request, _b, _c, fn, e_1_1, _fetch, response, error_1, finalError_1, _d, _e, fn, e_2_1, _f, _g, fn, e_3_1, result, parseAs, emptyData, _h, data, _j, textError, jsonError, error, finalError, _k, _l, fn, e_4_1;
        var e_1, _m, e_2, _o, e_3, _p, e_4, _q;
        var _r;
        return __generator(this, function (_s) {
            switch (_s.label) {
                case 0: return [4 /*yield*/, beforeRequest(options)];
                case 1:
                    _a = _s.sent(), opts = _a.opts, url = _a.url;
                    requestInit = __assign(__assign({ redirect: "follow" }, opts), { body: getValidRequestBody(opts) });
                    request = new Request(url, requestInit);
                    _s.label = 2;
                case 2:
                    _s.trys.push([2, 7, 8, 9]);
                    _b = __values(interceptors.request.fns), _c = _b.next();
                    _s.label = 3;
                case 3:
                    if (!!_c.done) return [3 /*break*/, 6];
                    fn = _c.value;
                    if (!fn) return [3 /*break*/, 5];
                    return [4 /*yield*/, fn(request, opts)];
                case 4:
                    request = _s.sent();
                    _s.label = 5;
                case 5:
                    _c = _b.next();
                    return [3 /*break*/, 3];
                case 6: return [3 /*break*/, 9];
                case 7:
                    e_1_1 = _s.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 9];
                case 8:
                    try {
                        if (_c && !_c.done && (_m = _b.return)) _m.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 9:
                    _fetch = opts.fetch;
                    _s.label = 10;
                case 10:
                    _s.trys.push([10, 12, , 21]);
                    return [4 /*yield*/, _fetch(request)];
                case 11:
                    response = _s.sent();
                    return [3 /*break*/, 21];
                case 12:
                    error_1 = _s.sent();
                    finalError_1 = error_1;
                    _s.label = 13;
                case 13:
                    _s.trys.push([13, 18, 19, 20]);
                    _d = __values(interceptors.error.fns), _e = _d.next();
                    _s.label = 14;
                case 14:
                    if (!!_e.done) return [3 /*break*/, 17];
                    fn = _e.value;
                    if (!fn) return [3 /*break*/, 16];
                    return [4 /*yield*/, fn(error_1, undefined, request, opts)];
                case 15:
                    finalError_1 = (_s.sent());
                    _s.label = 16;
                case 16:
                    _e = _d.next();
                    return [3 /*break*/, 14];
                case 17: return [3 /*break*/, 20];
                case 18:
                    e_2_1 = _s.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 20];
                case 19:
                    try {
                        if (_e && !_e.done && (_o = _d.return)) _o.call(_d);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 20:
                    finalError_1 = finalError_1 || {};
                    if (opts.throwOnError) {
                        throw finalError_1;
                    }
                    // Return error response
                    return [2 /*return*/, opts.responseStyle === "data"
                            ? undefined
                            : {
                                error: finalError_1,
                                request: request,
                                response: undefined,
                            }];
                case 21:
                    _s.trys.push([21, 26, 27, 28]);
                    _f = __values(interceptors.response.fns), _g = _f.next();
                    _s.label = 22;
                case 22:
                    if (!!_g.done) return [3 /*break*/, 25];
                    fn = _g.value;
                    if (!fn) return [3 /*break*/, 24];
                    return [4 /*yield*/, fn(response, request, opts)];
                case 23:
                    response = _s.sent();
                    _s.label = 24;
                case 24:
                    _g = _f.next();
                    return [3 /*break*/, 22];
                case 25: return [3 /*break*/, 28];
                case 26:
                    e_3_1 = _s.sent();
                    e_3 = { error: e_3_1 };
                    return [3 /*break*/, 28];
                case 27:
                    try {
                        if (_g && !_g.done && (_p = _f.return)) _p.call(_f);
                    }
                    finally { if (e_3) throw e_3.error; }
                    return [7 /*endfinally*/];
                case 28:
                    result = {
                        request: request,
                        response: response,
                    };
                    if (!response.ok) return [3 /*break*/, 44];
                    parseAs = (_r = (opts.parseAs === "auto"
                        ? getParseAs(response.headers.get("Content-Type"))
                        : opts.parseAs)) !== null && _r !== void 0 ? _r : "json";
                    if (!(response.status === 204 ||
                        response.headers.get("Content-Length") === "0")) return [3 /*break*/, 35];
                    emptyData = void 0;
                    _h = parseAs;
                    switch (_h) {
                        case "arrayBuffer": return [3 /*break*/, 29];
                        case "blob": return [3 /*break*/, 29];
                        case "text": return [3 /*break*/, 29];
                        case "formData": return [3 /*break*/, 31];
                        case "stream": return [3 /*break*/, 32];
                        case "json": return [3 /*break*/, 33];
                    }
                    return [3 /*break*/, 33];
                case 29: return [4 /*yield*/, response[parseAs]()];
                case 30:
                    emptyData = _s.sent();
                    return [3 /*break*/, 34];
                case 31:
                    emptyData = new FormData();
                    return [3 /*break*/, 34];
                case 32:
                    emptyData = response.body;
                    return [3 /*break*/, 34];
                case 33:
                    emptyData = {};
                    return [3 /*break*/, 34];
                case 34: return [2 /*return*/, opts.responseStyle === "data"
                        ? emptyData
                        : __assign({ data: emptyData }, result)];
                case 35:
                    data = void 0;
                    _j = parseAs;
                    switch (_j) {
                        case "arrayBuffer": return [3 /*break*/, 36];
                        case "blob": return [3 /*break*/, 36];
                        case "formData": return [3 /*break*/, 36];
                        case "json": return [3 /*break*/, 36];
                        case "text": return [3 /*break*/, 36];
                        case "stream": return [3 /*break*/, 38];
                    }
                    return [3 /*break*/, 39];
                case 36: return [4 /*yield*/, response[parseAs]()];
                case 37:
                    data = _s.sent();
                    return [3 /*break*/, 39];
                case 38: return [2 /*return*/, opts.responseStyle === "data"
                        ? response.body
                        : __assign({ data: response.body }, result)];
                case 39:
                    if (!(parseAs === "json")) return [3 /*break*/, 43];
                    if (!opts.responseValidator) return [3 /*break*/, 41];
                    return [4 /*yield*/, opts.responseValidator(data)];
                case 40:
                    _s.sent();
                    _s.label = 41;
                case 41:
                    if (!opts.responseTransformer) return [3 /*break*/, 43];
                    return [4 /*yield*/, opts.responseTransformer(data)];
                case 42:
                    data = _s.sent();
                    _s.label = 43;
                case 43: return [2 /*return*/, opts.responseStyle === "data"
                        ? data
                        : __assign({ data: data }, result)];
                case 44: return [4 /*yield*/, response.text()];
                case 45:
                    textError = _s.sent();
                    try {
                        jsonError = JSON.parse(textError);
                    }
                    catch (_t) {
                        // noop
                    }
                    error = jsonError !== null && jsonError !== void 0 ? jsonError : textError;
                    finalError = error;
                    _s.label = 46;
                case 46:
                    _s.trys.push([46, 51, 52, 53]);
                    _k = __values(interceptors.error.fns), _l = _k.next();
                    _s.label = 47;
                case 47:
                    if (!!_l.done) return [3 /*break*/, 50];
                    fn = _l.value;
                    if (!fn) return [3 /*break*/, 49];
                    return [4 /*yield*/, fn(error, response, request, opts)];
                case 48:
                    finalError = (_s.sent());
                    _s.label = 49;
                case 49:
                    _l = _k.next();
                    return [3 /*break*/, 47];
                case 50: return [3 /*break*/, 53];
                case 51:
                    e_4_1 = _s.sent();
                    e_4 = { error: e_4_1 };
                    return [3 /*break*/, 53];
                case 52:
                    try {
                        if (_l && !_l.done && (_q = _k.return)) _q.call(_k);
                    }
                    finally { if (e_4) throw e_4.error; }
                    return [7 /*endfinally*/];
                case 53:
                    finalError = finalError || {};
                    if (opts.throwOnError) {
                        throw finalError;
                    }
                    // TODO: we probably want to return error and improve types
                    return [2 /*return*/, opts.responseStyle === "data"
                            ? undefined
                            : __assign({ error: finalError }, result)];
            }
        });
    }); };
    var makeMethodFn = function (method) { return function (options) {
        return request(__assign(__assign({}, options), { method: method }));
    }; };
    var makeSseFn = function (method) { return function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, opts, url;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, beforeRequest(options)];
                case 1:
                    _a = _b.sent(), opts = _a.opts, url = _a.url;
                    return [2 /*return*/, createSseClient(__assign(__assign({}, opts), { body: opts.body, headers: opts.headers, method: method, onRequest: function (url, init) { return __awaiter(void 0, void 0, void 0, function () {
                                var request, _a, _b, fn, e_5_1;
                                var e_5, _c;
                                return __generator(this, function (_d) {
                                    switch (_d.label) {
                                        case 0:
                                            request = new Request(url, init);
                                            _d.label = 1;
                                        case 1:
                                            _d.trys.push([1, 6, 7, 8]);
                                            _a = __values(interceptors.request.fns), _b = _a.next();
                                            _d.label = 2;
                                        case 2:
                                            if (!!_b.done) return [3 /*break*/, 5];
                                            fn = _b.value;
                                            if (!fn) return [3 /*break*/, 4];
                                            return [4 /*yield*/, fn(request, opts)];
                                        case 3:
                                            request = _d.sent();
                                            _d.label = 4;
                                        case 4:
                                            _b = _a.next();
                                            return [3 /*break*/, 2];
                                        case 5: return [3 /*break*/, 8];
                                        case 6:
                                            e_5_1 = _d.sent();
                                            e_5 = { error: e_5_1 };
                                            return [3 /*break*/, 8];
                                        case 7:
                                            try {
                                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                                            }
                                            finally { if (e_5) throw e_5.error; }
                                            return [7 /*endfinally*/];
                                        case 8: return [2 /*return*/, request];
                                    }
                                });
                            }); }, url: url }))];
            }
        });
    }); }; };
    return {
        buildUrl: buildUrl,
        connect: makeMethodFn("CONNECT"),
        delete: makeMethodFn("DELETE"),
        get: makeMethodFn("GET"),
        getConfig: getConfig,
        head: makeMethodFn("HEAD"),
        interceptors: interceptors,
        options: makeMethodFn("OPTIONS"),
        patch: makeMethodFn("PATCH"),
        post: makeMethodFn("POST"),
        put: makeMethodFn("PUT"),
        request: request,
        setConfig: setConfig,
        sse: {
            connect: makeSseFn("CONNECT"),
            delete: makeSseFn("DELETE"),
            get: makeSseFn("GET"),
            head: makeSseFn("HEAD"),
            options: makeSseFn("OPTIONS"),
            patch: makeSseFn("PATCH"),
            post: makeSseFn("POST"),
            put: makeSseFn("PUT"),
            trace: makeSseFn("TRACE"),
        },
        trace: makeMethodFn("TRACE"),
    };
};
